import { ASSIGN_ENTITY_FROM_GROUP_SUCCESS } from 'modules/groups/actionTypes';
import * as types from 'modules/vehicleCheckModels/actionTypes';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

/** @type {import('utils/ReduxUtils').EntityAdapter<import('../types').VehicleCheckModel>} */
export const vehicleChecksAdapter = createEntityAdapter({ selectId: ({ id }) => id });

const addFromPage = (state, { payload: { content } }) => vehicleChecksAdapter.updateMany(state, content);

export default createReducer(
  vehicleChecksAdapter.getInitialState(),
  {
    [types.FETCH_VEHICLE_CHECK_MODELS_SUCCESS]: addFromPage,
    [types.CLONE_VEHICLE_CHECK_MODEL_SUCCESS]: vehicleChecksAdapter.addOne,
    [types.CREATE_VEHICLE_CHECK_MODEL_SUCCESS]: vehicleChecksAdapter.addOne,
    [types.FETCH_VEHICLE_CHECK_MODEL_SUCCESS]: vehicleChecksAdapter.updateOne,
    [types.UPDATE_VEHICLE_CHECK_MODEL_SUCCESS]: vehicleChecksAdapter.updateOne,
    [types.DELETE_VEHICLE_CHECK_MODEL_SUCCESS]: vehicleChecksAdapter.removeOne,
    [types.FETCH_DEFAULT_VEHICLE_CHECK_MODEL_SUCCESS]: vehicleChecksAdapter.addOne,
  },
  [
    {
      matcher: ({ type, meta }) => type === ASSIGN_ENTITY_FROM_GROUP_SUCCESS && meta?.source === 'vehicleCheckModel',
      reducer: vehicleChecksAdapter.updateOne,
    },
  ]
);
